export default {
  LOAD_ADVISEES (state, payload) {
    state.advisees = payload
  },
  LOAD_TOTAL (state, payload) {
    state.total = payload
  },
  LOAD_PAGE (state, payload) {
    state.page = payload
  },
  LOAD_COUNT (state, payload) {
    state.count = payload
  },
  LOAD_NAMED_QUERY_ENABLED (state, payload) {
    state.isNamedQueriesEnabled = payload
  }
}



// WEBPACK FOOTER //
// ./src/app/adviseeTracker/vuex/mutations.js